import styled, { css, keyframes } from "styled-components"


const extendFromRight = keyframes`
  0% {
    right: -470px;
  }
  100% {
    right: 0;
  }
`
const collapseToRight = keyframes`
  0% {
    right: 0;
  }
  100% {
    right: -470px;
  }
`

export const DropdownContainerWrapper = styled.div<{ isShow: boolean; residualHeight: number }>`
    width: 470px;
    position: fixed;
    right: 0;
    top: initial;
    bottom: 0;
    z-index: 9;
    height: calc(100% - ${({residualHeight}) => residualHeight}px);
    animation: ${({ isShow }) => isShow ? extendFromRight : collapseToRight} 0.25s ease-in-out forwards;
`

export const DropdownContainerBodyWrapper = styled.div<{ isShow: boolean; isMobile: boolean }>`
    border-radius: 12px 0 0 12px;
    background-color: #fff;
    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.16);
    padding: 24px;
    height: 100%;
    ${({ isMobile }) => {
        if (isMobile) {
            return ''
        }
        return css<{ isShow: boolean }>`
            will-change: transform;
            overflow: hidden;
        `
    }}
`

export const HeaderTitle = styled.span`
    color: #000;
    font-size: 20px;
    font-weight: 600;
    display: block;
    width: 100%;
`

export const CloseIcon = styled.span`
    float: right;
    cursor: pointer;
    &:hover {
        svg {
            path {
                fill: #333;
            }
        }
    }
`

export const Background = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.4);
    z-index: 10;
`
